export default () => {
  return process.env.PLATFORM === 'node' ? process.env.API_PROXY_TARGET : '/'
}
